export const getFileNameFromUrl = url =>
  url
    .split('/')
    .pop()
    .replace(/-\d*\./gi, '.') || 'Liite'
